import { callGetApiToServer } from "../callApi";

export async function getAllAdmin(authtoken, skipNumber, limitNumber) {
  console.log(authtoken,limitNumber);
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl = "v1/admin/list-admin/" + skipNumber + "/" + limitNumber;

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
